module.exports = __webpack_public_path__ + "img/46.f2ef0da8.jpg";